const Foot = function({children, buttons}) {
  return (
    <div className="flex items-right justify-end p-4 md:p-5 border-t border-gray-200 rounded-b">
      {children}
    </div>
  )
}

export default Foot
